import { render, staticRenderFns } from "./CommissionCard.vue?vue&type=template&id=4b2898e6&scoped=true&"
import script from "./CommissionCard.vue?vue&type=script&lang=js&"
export * from "./CommissionCard.vue?vue&type=script&lang=js&"
import style0 from "./CommissionCard.vue?vue&type=style&index=0&id=4b2898e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2898e6",
  null
  
)

export default component.exports